import { render, staticRenderFns } from "./ProspectionSuggestionAIBox.vue?vue&type=template&id=6dc19a8c&scoped=true"
import script from "./ProspectionSuggestionAIBox.vue?vue&type=script&lang=js"
export * from "./ProspectionSuggestionAIBox.vue?vue&type=script&lang=js"
import style0 from "./ProspectionSuggestionAIBox.vue?vue&type=style&index=0&id=6dc19a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc19a8c",
  null
  
)

export default component.exports